<template>
  <div>
    <b-row>
      <b-col
        v-if="!isBuyerTicket"
        md="3"
      >
        <validation-provider
          #default="{ errors }"
          name="Invoice Item No."
          :vid="`${validationId}_invoice_item_no`"
          rules="required"
        >
          <b-form-group
            label="Invoice Item No."
          >
            <b-form-input
              v-model="record.invoiceItemNumber"
              :state="errors.length > 0 ? false:null"
              type="number"
              min="0"
              placeholder="Invoice Item No."
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>
      </b-col>

      <b-col md="3">
        <validation-provider
          #default="{ errors }"
          name="Item Name"
          :vid="`${validationId}_item_name`"
          rules="required"
        >
          <b-form-group
            label="Item Name"
            :state="errors.length > 0 ? false : null"
          >
            <custom-v-select
              v-model="record.itemName"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="itemOptions"
              label="text"
              placeholder="Select Item Name"
              :state="errors.length > 0 ? false:null"
              :reduce="option => option.id"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>
      </b-col>

      <b-col md="3">
        <validation-provider
          #default="{ errors }"
          name="Remarks"
          :vid="`${validationId}_remarks`"
          rules="required"
        >
          <b-form-group
            label="Remarks"
          >
            <b-form-textarea
              v-model="record.remarks"
              :state="errors.length > 0 ? false:null"
              rows="1"
              placeholder="Remaks"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import {
  BRow, BCol, BFormGroup, BFormInput, BFormTextarea,
} from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'
import { isEqual, cloneDeep } from 'lodash'

import CustomVSelect from '@/components/UI/CustomVSelect.vue'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    ValidationProvider,
    CustomVSelect,
    BFormTextarea,
  },
  props: {
    itemOptions: {
      type: Array,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
    validationId: {
      type: String,
      required: true,
    },
    isBuyerTicket: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      record: {},
    }
  },
  computed: {
    out() {
      return cloneDeep(this.record)
    },
  },
  watch: {
    out: {
      handler(val) {
        if (!isEqual(val, this.value)) {
          this.$emit('input', val)
        }
      },
      deep: true,
    },
    value: {
      handler(val) {
        if (!isEqual(val, this.out)) {
          this.setInternalState()
        }
      },
      deep: true,
    },
  },
  created() {
    this.setInternalState()
  },
  methods: {
    setInternalState() {
      this.record = cloneDeep(this.value)
    },
  },
}
</script>
